
// TODO uh oh need to build the image to use this

export function getBackendURL() {
    return 'https://api.thepersonaltrainersclub.com';
    // return 'http://localhost:19027';
    // return process.env.REACT_APP_BACKEND_URL || 'http://localhost:19027';
}